export function formattedValuesToSubmit(data) {
  delete data.reportType;
  return data;
}
